import { FunctionComponent as F } from "react";
import Box from "@mui/material/Box";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Button from "../../components/UI/Button/Button";


interface IProps
{
  open: boolean,
  handleCancel: () => void,
  handleOk: () => void
}

const ReplaceProtocolDialog: F<IProps> = (props: IProps) =>
{
  return (
    <Dialog
      open={props.open}
      maxWidth='md'
      PaperProps={{ sx: { p: '15px', textAlign: 'center' }}}
      onClose={props.handleCancel}>
      <DialogTitle sx={{ fontSize: '30px' }}>Replace protocol</DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{ paddingBottom: '24px' }}>
          {"Your existing protocol will be replaced with this combination."}
          <br/>
          {"Are you sure you want to proceed?"}
        </Typography>
        <Button
          label='Cancel'
          onClick={props.handleCancel}/>
        <Button
          onClick={props.handleOk}
          label='Ok'/>
        <Box style={{ display: 'inline', paddingLeft: '14px' }} />
      </DialogContent>
    </Dialog>);
}

export default ReplaceProtocolDialog;

